import { render } from "./LinkedInSuggestions.vue?vue&type=template&id=586ca493"
import script from "./LinkedInSuggestions.vue?vue&type=script&lang=js"
export * from "./LinkedInSuggestions.vue?vue&type=script&lang=js"

import "./LinkedInSuggestions.vue?vue&type=style&index=0&id=586ca493&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__